module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "non-legacy-invoices-modal__overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        !_vm.isSaving && _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "non-legacy-invoices-modal__container bg-lightest py-3 px-4"
  }, [_c('div', {
    staticClass: "text-center fs-larger font-weight-600 pb-2 dark-top"
  }, [_vm._v("\n            Non Legacy Invoices\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "non-legacy-invoices-modal__divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "non-legacy-invoices-modal__body p-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Payment\n                "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.paymentOptions,
      "searchable": false,
      "disabled": _vm.isSaving,
      "label": "label",
      "placeholder": "Select a payment"
    },
    on: {
      "input": _vm.onPaymentSelected
    },
    model: {
      value: (_vm.selectedPayment),
      callback: function($$v) {
        _vm.selectedPayment = $$v
      },
      expression: "selectedPayment"
    }
  })], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "non-legacy-invoices-modal__divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "btn tertiary mr-2",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('loading-button', {
    staticClass: "btn blue",
    attrs: {
      "disabled": !_vm.selectedPayment,
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("\n                Save\n            ")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-846a6778", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-846a6778"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabPayments/NonLegacyInvoicesModal.vue
// module id = 1982
// module chunks = 0